/** @jsx jsx */
import React, { useCallback } from 'react';
import { jsx } from '@emotion/core';
import Button from '../../Button';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import useWorkflow from 'hooks/useWorkflow';
import useReactRouter from 'use-react-router';

interface PropTypes {
  tMdKey: string;
}

const BackToPrevious: React.FC<PropTypes> = props => {
  const tMd = useMarkdownTranslate();
  const { goBack } = useNavigationHelpers();
  const {
    location: { pathname },
  } = useReactRouter();
  const {
    steps,
    workflow: { paths },
  } = useWorkflow();

  const shouldDisplayBackToPrevious = pathname !== paths[steps[0]];

  const onPress = useCallback(() => {
    goBack();
  }, [goBack]);

  const { tMdKey } = props;

  return shouldDisplayBackToPrevious ? (
    <Button id="backToPrevious" onClick={onPress} variant="text">
      {tMd(tMdKey)}
    </Button>
  ) : null;
};

export default BackToPrevious;
